export default class IdName {
	readonly id: number;
	readonly name: string;

	constructor(json: any) {
		this.id = json.id;
		this.name = json.name;
	}
}
